<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5099 6.06L19.3645 7.0275C20.5413 8.42395 21.1686 10.2028 21.1286 12.0299C21.0886 13.857 20.3841 15.6065 19.1473 16.95L20.2479 18C21.733 16.3879 22.5793 14.2878 22.6275 12.0946C22.6758 9.90146 21.9227 7.76613 20.5099 6.09V6.06Z"
      fill="#777FF6"
    />
    <path
      d="M16.3323 9C17.0382 9.83852 17.4141 10.9064 17.3892 12.003C17.3644 13.0996 16.9406 14.1494 16.1975 14.955L17.2981 15.975C18.2885 14.8998 18.8526 13.4991 18.8843 12.0364C18.9161 10.5737 18.4132 9.14979 17.4703 8.0325L16.3323 9Z"
      fill="#777FF6"
    />
    <path
      d="M13.652 22.5C13.553 22.4996 13.455 22.4795 13.3637 22.4409C13.2725 22.4022 13.1898 22.3459 13.1205 22.275L7.41552 16.5H2.42181C2.22325 16.5 2.03282 16.421 1.89241 16.2803C1.752 16.1397 1.67313 15.9489 1.67313 15.75V8.25C1.67313 8.05109 1.752 7.86032 1.89241 7.71967C2.03282 7.57902 2.22325 7.5 2.42181 7.5H7.41552L13.1205 1.725C13.2607 1.58531 13.4505 1.5069 13.6483 1.5069C13.8461 1.5069 14.0358 1.58531 14.1761 1.725C14.3172 1.86347 14.3979 2.05217 14.4007 2.25V21.75C14.4007 21.9489 14.3218 22.1397 14.1814 22.2803C14.041 22.421 13.8506 22.5 13.652 22.5ZM3.17049 15H7.72248C7.82153 15.0004 7.91952 15.0205 8.01077 15.0591C8.10201 15.0978 8.1847 15.1541 8.25404 15.225L12.9034 19.9275V4.0725L8.25404 8.775C8.1847 8.84586 8.10201 8.90224 8.01077 8.94087C7.91952 8.97949 7.82153 8.99959 7.72248 9H3.17049V15Z"
      fill="#777FF6"
    />
  </svg>
</template>
<script>
export default {
  name: "VolumeIcon",
};
</script>
